/**
 * Gestion du bandeau supérieur
 * - Masque le bandeau au scroll vers le bas
 * - Réaffiche le bandeau au scroll vers le haut
 * - Ajuste automatiquement l'espacement du contenu
 */

(function () {
  'use strict';

  function init() {
    const unifiedHeader = document.getElementById('unified-header');
    const sectionHeader = unifiedHeader ? unifiedHeader.closest('.section-header') : null;
    const topBanner = document.getElementById('top-banner');

    if (!sectionHeader || !topBanner) {
      // Si pas de bandeau, pas de logique nécessaire
      if (sectionHeader && !topBanner) {
        // Créer un spacer pour le header seul
        let headerSpacer = document.getElementById('header-spacer');
        if (!headerSpacer) {
          headerSpacer = document.createElement('div');
          headerSpacer.id = 'header-spacer';
          headerSpacer.style.height = sectionHeader.offsetHeight + 'px';
          sectionHeader.parentNode.insertBefore(headerSpacer, sectionHeader.nextSibling);
        }
      }
      return;
    }

    // Créer un spacer pour compenser le header fixed
    let headerSpacer = document.getElementById('header-spacer');
    if (!headerSpacer) {
      headerSpacer = document.createElement('div');
      headerSpacer.id = 'header-spacer';
      sectionHeader.parentNode.insertBefore(headerSpacer, sectionHeader.nextSibling);
    }

    let lastScrollY = window.scrollY;
    let ticking = false;
    const scrollThreshold = 500; // Seuil pour cacher le bandeau (scroll down)
    const scrollThresholdReappear = 500; // Seuil pour réafficher le bandeau (scroll up)

    function adjustSpacerHeight() {
      headerSpacer.style.height = sectionHeader.offsetHeight + 'px';
    }

    function updateBannerVisibility() {
      const currentScrollY = window.scrollY;
      const wasBannerHidden = topBanner.classList.contains('banner-hidden');

      // Si on scroll vers le bas et qu'on dépasse le seuil de masquage
      if (currentScrollY > scrollThreshold && currentScrollY > lastScrollY) {
        if (!wasBannerHidden) {
          topBanner.classList.add('banner-hidden');
        }
      }
      // Si on scroll vers le haut ET qu'on est en dessous du seuil de réapparition
      else if (currentScrollY < lastScrollY && currentScrollY <= scrollThresholdReappear) {
        if (wasBannerHidden) {
          topBanner.classList.remove('banner-hidden');
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateBannerVisibility);
        ticking = true;
      }
    }

    // Écouter le scroll avec throttling via requestAnimationFrame
    window.addEventListener('scroll', onScroll, { passive: true });

    // Ajuster le spacer au chargement et au resize
    adjustSpacerHeight();
    // Sur Chrome, le resize peut spammer l'event et provoquer des recalculs layout.
    // On throttle via requestAnimationFrame pour garder le resize fluide.
    let resizeRafId = 0;
    function onResize() {
      if (resizeRafId) window.cancelAnimationFrame(resizeRafId);
      resizeRafId = window.requestAnimationFrame(() => {
        resizeRafId = 0;
        adjustSpacerHeight();
      });
    }
    window.addEventListener('resize', onResize, { passive: true });

    // Observer les changements de hauteur du header
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(adjustSpacerHeight);
      resizeObserver.observe(sectionHeader);
    }

    // Init
    updateBannerVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

